module.exports = __webpack_public_path__ + "img/picture_bg.5a84d4b4.png";